export default "__VITE_ASSET__T$nrvQaR__"